import { Component } from 'react'
import { injectIntl } from 'react-intl'

import notification from 'src/components/Notification'
import intlMessages from './translations'

class OfflineStatus extends Component {
  componentDidUpdate() {
    const { intl, isOffline } = this.props

    if (!isOffline.online) {
      notification.info({
        message: intl.formatMessage(intlMessages.offlineStatusMessage),
        description: intl.formatMessage(intlMessages.offlineStatusDescription)
      })
    }
  }

  render() {
    return null
  }
}

export default injectIntl(OfflineStatus)
